import { useContext } from 'react';
import { ModuleScopeContext } from '../components/context/ModuleScopeProvider';

const useScopes = () => {
  const { access } = useContext(ModuleScopeContext);
  return { access };
};

export default useScopes;
